import { useCallback } from 'react'
import { createActorContext as createXStateActorContext } from '@xstate/react'
import type { AnyActorLogic, EventFromLogic } from 'xstate'

export function createActorContext<TLogic extends AnyActorLogic>(logic: TLogic) {
  const actorContext = createXStateActorContext(logic)

  return {
    ...actorContext,
    useActor: () => {
      const actorRef = actorContext.useActorRef()
      const snapshot = actorContext.useSelector((state) => state)
      const send = useCallback((event: EventFromLogic<TLogic>) => actorRef.send(event), [actorRef])

      return [snapshot, send] as const
    },
  }
}
